'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var MarketsLegsResponsibilitiesController = function MarketsLegsResponsibilitiesController($scope, UserManagementConstants, UserManagementDataService, UserFactory, $log, $q, userSecureService, featureToggleService) {
  var assignedValues = {};
  $scope.loadData = function () {
    return userSecureService.retrieveSpecifiedUser($scope.user.userId).then(function (userData) {
      $scope.user = userData;
      $scope.location = $scope.user.cityCode;
      $scope.email = $scope.user.email;
      $scope.userName = $scope.user.firstName + ' ' + $scope.user.lastName;
    });
  };
  function isOnlyPreferenceChanges() {
    return $scope.isOwnProfile;
  }
  $scope.fetchMarketsAndLegs = function () {
    var userSettings = {
      responsibilities: {
        markets: [],
        legs: []
      },
      preferences: {
        markets: [],
        legs: []
      }
    };
    if ($scope.user.responsibilities) {
      userSettings.responsibilities.markets = $scope.user.responsibilities.markets;
      userSettings.responsibilities.legs = $scope.user.responsibilities.legs;
    }
    if ($scope.user.preferences) {
      userSettings.preferences.markets = $scope.user.preferences.markets;
      userSettings.preferences.legs = $scope.user.preferences.legs;
    }
    if (!isOnlyPreferenceChanges()) {
      return UserManagementDataService.getAllUsers().then(function (users) {
        assignedValues = users;
        return populatePreferences(userSettings, $scope.isOwnProfile);
      });
    } else {
      return populatePreferences(userSettings, $scope.isOwnProfile);
    }
  };
  function populatePreferences(userSettings, isOwnProfile) {
    var markets = UserManagementDataService.getMarkets();
    var nonCodeShareMarkets = _.filter(markets, {
      isCodeShare: false
    });
    if (!isOnlyPreferenceChanges()) {
      $scope.matchMarket = matchMarketsToUsers(nonCodeShareMarkets, assignedValues);
      $scope.matchMarketsToNames = matchMarketsToUserNames(nonCodeShareMarkets, assignedValues);
      $scope.marketResponsibilities = setUserSelections(nonCodeShareMarkets, userSettings.responsibilities.markets);
    }
    $scope.marketPreferences = setUserSelections(nonCodeShareMarkets, userSettings.preferences.markets);
    if (featureToggleService.isDisabled('REVENUE_OPTIMIZER')) {
      return;
    }
    return UserManagementDataService.getLegs().then(function (legs) {
      var nonCodeShareLegs = _.intersectionBy(legs, nonCodeShareMarkets, 'value');
      if (!isOwnProfile) {
        $scope.matchLeg = matchLegsToUsers(nonCodeShareLegs, assignedValues);
        $scope.matchLegsToNames = matchLegsToUserNames(nonCodeShareLegs, assignedValues);
        $scope.legResponsibilities = setUserSelections(nonCodeShareLegs, userSettings.responsibilities.legs);
      }
      $scope.legPreferences = setUserSelections(nonCodeShareLegs, userSettings.preferences.legs);
    });
  }

  // function copyResponsibilitiesToPreferencesForDA() {
  //     if (featureToggleService.isEnabled('DYNAMIC_AVAILABILITY')) {
  //         $scope.userSelectedMarketPreferences = $scope.userSelectedMarketResponsibilities;
  //     }
  // }

  $scope.saveSelections = function () {
    UserManagementDataService.updateUserLegsAndPrefs($scope.user, $scope.userSelectedMarketResponsibilities, $scope.userSelectedMarketPreferences, $scope.userSelectedLegResponsibilities, $scope.userSelectedLegPreferences, isOnlyPreferenceChanges()).then(function () {
      if ($scope.isRevenueOptimizerEnabled()) {
        $scope.updateMarketAndLegStaticData();
      }
      toastr.success('User responsibility and preferences saved');
      close();
    })["catch"](function () {
      $log.error('MarketsLegsResponsibilitiesController: UserManagementDataService.updateUserLegsAndPrefs - Error: User responsibility and preferences not saved');
      toastr.error('Error: User responsibility and preferences not saved');
    });
  };
  $scope.updateMarketAndLegStaticData = function () {
    var userFactory = new UserFactory($scope.user);
    return $q.all([UserManagementDataService.updateMarkets($scope.userSelectedMarketResponsibilities, userFactory.getUserId()), UserManagementDataService.updateLegMarkets($scope.userSelectedLegResponsibilities, userFactory.getUserId())]).then(function () {
      return userSecureService.refreshUserConfig();
    });
  };
  $scope.removeResponsibilitiesFromAssignedUsers = function () {
    var usersWithModifiedMarketResponsibilities = $scope.identifyUsersWithModifiedMarketResponsibilities();
    var usersWithModifiedLegResponsibilities = $scope.identifyUsersWithModifiedLegResponsibilities();
    $scope.updateResponsibilitiesOfAssignedUsers(_.union(usersWithModifiedMarketResponsibilities, usersWithModifiedLegResponsibilities));
  };
  $scope.identifyUsersWithModifiedMarketResponsibilities = function () {
    var filteredAssignedMarkets = _.pickBy($scope.matchMarket, function (u, m) {
      return !!(u && u !== $scope.user.userId && _.includes($scope.userSelectedMarketResponsibilities, m));
    });
    return _.transform(filteredAssignedMarkets, function (result, u, m) {
      var user = _.find(assignedValues, {
        'userId': u
      });
      if (user) {
        _.pull(user.responsibilities.markets, m);
        _.pull(user.preferences.markets, m);
        result.push(u);
      }
    }, []);
  };
  $scope.identifyUsersWithModifiedLegResponsibilities = function () {
    var filteredAssignedLegs = _.pickBy($scope.matchLeg, function (u, l) {
      return !!(u && u !== $scope.user.userId && _.includes($scope.userSelectedLegResponsibilities, l));
    });
    return _.transform(filteredAssignedLegs, function (result, u, l) {
      var user = _.find(assignedValues, {
        'userId': u
      });
      if (user) {
        _.pull(user.responsibilities.legs, l);
        _.pull(user.preferences.legs, l);
        result.push(u);
      }
    }, []);
  };
  $scope.updateResponsibilitiesOfAssignedUsers = function (userIndices) {
    var filteredUsers = _.filter(assignedValues, function (u) {
      return _.includes(userIndices, u.userId);
    });
    var modifiedUsers = _.transform(filteredUsers, function (result, u) {
      var updatedUserData = UserManagementDataService.prepareUserPayload(u, u.responsibilities.markets, u.preferences.markets, u.responsibilities.legs, u.preferences.legs);
      result.push(updatedUserData);
    }, []);
    if (modifiedUsers.length > 0) {
      UserManagementDataService.updateMultipleUsers(modifiedUsers)["catch"](function () {
        $log.error('MarketsLegsResponsibilitiesController: UserManagementDataService.updateMultipleUsers - Error: Responsibilities and preferences were not removed from other assigned users');
        toastr.error('Error: Responsibilities and preferences were not removed from other assigned users');
      });
    }
  };
  $scope.cancel = function () {
    close();
  };
  $scope.$watch('userSelectedMarketResponsibilities', function (newValues, oldValues) {
    _.forEach(oldValues, function (oldValue) {
      if (!_.includes(newValues, oldValue)) {
        if (_.includes($scope.userSelectedMarketPreferences, oldValue)) {
          _.forEach($scope.marketPreferences, function (marketPreference) {
            if (marketPreference.value === oldValue) {
              $scope.marketPreferences = uncheckPreference(oldValue, $scope.marketPreferences, $scope.userSelectedMarketPreferences);
            }
          });
        }
      }
    });
  });
  $scope.$watch('userSelectedLegResponsibilities', function (newValues, oldValues) {
    _.forEach(oldValues, function (oldValue) {
      if (!_.includes(newValues, oldValue)) {
        if (_.includes($scope.userSelectedLegPreferences, oldValue)) {
          _.forEach($scope.legPreferences, function (legPreference) {
            if (legPreference.value === oldValue) {
              $scope.legPreferences = uncheckPreference(oldValue, $scope.legPreferences, $scope.userSelectedLegPreferences);
            }
          });
        }
      }
    });
  });
  $scope.$watchGroup(['isResponsibilityLegsCopyFromMarketResponsibilty', 'isPreferencesMarketsCopyFromMarketResponsibilty', 'userSelectedMarketResponsibilities'], function (newValues) {
    if (newValues[0]) {
      //copy selections from market responsibilities to leg responsibiltiies
      $scope.legResponsibilities = copySelections($scope.userSelectedMarketResponsibilities, $scope.legResponsibilities);
    }
    if (newValues[1]) {
      //copy selections for market responsibilities to market preferences
      $scope.marketPreferences = copySelections($scope.userSelectedMarketResponsibilities, $scope.marketPreferences);
    }
  });
  $scope.$watchGroup(['isPreferencesLegsCopyFromLegsResponsibilty', 'userSelectedLegResponsibilities'], function (newValues) {
    if (newValues[0]) {
      //copy selections from leg responsbilities to leg preferences
      $scope.legPreferences = copySelections($scope.userSelectedLegResponsibilities, $scope.legPreferences);
    }
  });
  $scope.isRevenueOptimizerEnabled = function () {
    return featureToggleService.isEnabled('REVENUE_OPTIMIZER');
  };
  function close() {
    if ($scope.isOwnProfile) {
      $scope.$emit('user-profile:change-screen', UserManagementConstants.USER_PROFILE_SCREENS.USER_PROFILE);
    } else {
      $scope.$emit('user-management-manage-users:change-screen', UserManagementConstants.MANAGE_USERS_SCREENS.USER_PROFILE);
    }
  }
  function copySelections(from, to) {
    return _.map(to, function (toItem) {
      var selected = _.includes(from, toItem.value);
      return {
        selected: selected,
        value: toItem.value
      };
    });
  }
  function uncheckPreference(from, collections, checkedValues) {
    return _.map(collections, function (collection) {
      if (collection.value === from || !_.includes(checkedValues, collection.value)) {
        return {
          selected: false,
          value: collection.value
        };
      } else {
        return {
          selected: true,
          value: collection.value
        };
      }
    });
  }

  // function setUserSelectionsWithAssignedUserName(allValues, userSelections, matchResposibilitiesNames, title) {
  //     var assignedMessage = _.template('Assigned to <%= user %>');
  //     var assignedWarningMessage = _.template('<%= title %> will be removed from <%= user %>');
  //     return _.map(allValues, function (selection) {
  //         return {
  //             selected: _.includes(userSelections, selection.value),
  //             value: selection.value,
  //             assigned: Boolean(matchResposibilitiesNames[selection.value] || false),
  //             assignedMessage: Boolean(matchResposibilitiesNames[selection.value]) ? assignedMessage({user: matchResposibilitiesNames[selection.value]}) : '',
  //             assignedWarningmessage: Boolean(matchResposibilitiesNames[selection.value]) ? assignedWarningMessage({
  //                 title: title,
  //                 user: matchResposibilitiesNames[selection.value]
  //             }) : ''
  //         };
  //     });
  // }

  function setUserSelections(allValues, userSelections) {
    return _.map(allValues, function (selection) {
      return {
        selected: _.includes(userSelections, selection.value),
        value: selection.value
      };
    });
  }
  function matchMarketsToUsers(markets, assignedUsers) {
    var result = {};
    _.forEach(markets, function (market) {
      result[market.value] = null;
      _.forEach(assignedUsers, function (user) {
        if (_.includes(user.responsibilities.markets, market.value)) {
          result[market.value] = user.userId;
        }
      });
    });
    return result;
  }
  function matchLegsToUsers(legs, assignedUsers) {
    var result = {};
    _.forEach(legs, function (leg) {
      result[leg.value] = null;
      _.forEach(assignedUsers, function (user) {
        if (_.includes(user.responsibilities.legs, leg.value)) {
          result[leg.value] = user.userId;
        }
      });
    });
    return result;
  }
  function matchMarketsToUserNames(markets, assignedUsers) {
    var result = {};
    _.forEach(markets, function (market) {
      result[market.value] = null;
      _.forEach(assignedUsers, function (user) {
        if (_.includes(user.responsibilities.markets, market.value) && user.userId !== $scope.user.userId) {
          result[market.value] = user.firstName + ' ' + user.lastName;
        }
      });
    });
    return result;
  }
  function matchLegsToUserNames(legs, assignedUsers) {
    var result = {};
    _.forEach(legs, function (leg) {
      result[leg.value] = null;
      _.forEach(assignedUsers, function (user) {
        if (_.includes(user.responsibilities.legs, leg.value) && user.userId !== $scope.user.userId) {
          result[leg.value] = user.firstName + ' ' + user.lastName;
        }
      });
    });
    return result;
  }
};
MarketsLegsResponsibilitiesController.$inject = ['$scope', 'UserManagementConstants', 'UserManagementDataService', 'UserFactory', '$log', '$q', 'UserSecureService', 'FeatureToggleService'];
module.exports = MarketsLegsResponsibilitiesController;